export const NOTICES_EDIT_CCAA_PROFILES = [
  "instalador",
  "administrador",
  "admin_captador_grabador",
]
